export const getStoreCountryCode = () =>
  document.querySelector("html").dataset.countryCode;
export const isCanada = () => getStoreCountryCode() === "CA";
export const isUSA = () => getStoreCountryCode() === "US";
export const isUK = () => getStoreCountryCode() === "GB";

export default getStoreCountryCode;
